import { render } from "./AuditReportYearWise.vue?vue&type=template&id=10abcc10&scoped=true"
import script from "./AuditReportYearWise.vue?vue&type=script&lang=js"
export * from "./AuditReportYearWise.vue?vue&type=script&lang=js"

import "./AuditReportYearWise.vue?vue&type=style&index=0&id=10abcc10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10abcc10"]])

export default __exports__